import { publishReplay, refCount, scan, startWith } from "rxjs/operators";
import { BehaviorSubject, Subject } from "rxjs";
import { EventEmitter } from "../utils/EventEmitter";
export class Component extends EventEmitter {
    constructor(name, container, navigator) {
        super();
        this._activated$ = new BehaviorSubject(false);
        this._configurationSubject$ = new Subject();
        this._activated = false;
        this._container = container;
        this._name = name;
        this._navigator = navigator;
        this._configuration$ = this._configurationSubject$.pipe(startWith(this.defaultConfiguration), scan((conf, newConf) => {
            for (const key in newConf) {
                if (Object.prototype.hasOwnProperty.call(newConf, key)) {
                    conf[key] = newConf[key];
                }
            }
            return conf;
        }), publishReplay(1), refCount());
        this._configuration$.subscribe(() => {
            /*noop*/
        });
    }
    get activated() {
        return this._activated;
    }
    /** @ignore */
    get activated$() {
        return this._activated$;
    }
    /**
     * Get default configuration.
     *
     * @returns {TConfiguration} Default configuration for component.
     */
    get defaultConfiguration() {
        return this._getDefaultConfiguration();
    }
    /** @ignore */
    get configuration$() {
        return this._configuration$;
    }
    /**
     * Get name.
     *
     * @description The name of the component. Used when interacting with the
     * component through the Viewer's API.
     */
    get name() {
        return this._name;
    }
    activate(conf) {
        if (this._activated) {
            return;
        }
        if (conf !== undefined) {
            this._configurationSubject$.next(conf);
        }
        this._activated = true;
        this._activate();
        this._activated$.next(true);
    }
    configure(conf) {
        this._configurationSubject$.next(conf);
    }
    deactivate() {
        if (!this._activated) {
            return;
        }
        this._activated = false;
        this._deactivate();
        this._container.domRenderer.clear(this._name);
        this._activated$.next(false);
    }
    /**
     * Detect the viewer's new width and height and resize the component's
     * rendered elements accordingly if applicable.
     *
     * @ignore
     */
    resize() {
        return;
    }
}
Component.componentName = "not_worthy";
//# sourceMappingURL=Component.js.map